import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "liucheng_btn" }

import { toRefs, ref, watchEffect } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'nextStepButton',
  props: {
        step: Number,
        publicData:Object
    },
  emits: ['nextStep','prevStep'],
  setup(__props, { emit: __emit }) {

    const props = __props
    const {step,publicData} = toRefs(props)

    let nextText = ref('下一步')
    watchEffect(() => {
        if(step?.value === 4){
            nextText.value = '提交'
        }else if(step?.value === 5){
            nextText.value = '用户空间'
        }else{
            nextText.value = '下一步'
        }
    })

    const emit = __emit
    const prev = () => {
        emit('prevStep',step!.value!)
    }
    const next = () => {
        console.log('????????');
        
        emit('nextStep',step!.value!)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(step) === 2 || _unref(step) === 3 || _unref(step) === 4)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "lcbtn1",
          onClick: prev
        }, "上一步"))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      class: "lcbtn2",
      onClick: next
    }, _toDisplayString(_unref(nextText)), 1)
  ]))
}
}

})